<template>
  <div :class="['expandable-information', { 'expandable-information--is-expanded': isExpanded }]">
    <button class="expandable-information__toggler" @click="toggleContent()">
      <oie-use-svg svg="information"></oie-use-svg> {{ title }}
    </button>

    <div v-show="isExpanded" class="expandable-information__content">
      {{ content }}

      <slot name="content"></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true
    },
    content: {
      type: String,
      required: true
    }
  },
  data: () => ({
    isExpanded: false
  }),
  methods: {
    toggleContent() {
      this.isExpanded = !this.isExpanded
    }
  }
}
</script>

<style lang="scss">
.expandable-information {
  max-width: 65ch;
}

.expandable-information__toggler {
  @include reset-button;
  overflow: hidden;

  &::after {
    content: '';
    width: 1rem;
    height: 0.5rem;
    background-image: url("data:image/svg+xml,%3Csvg width='21' height='14' viewBox='0 0 21 14' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M10.577 9.534L18.73.22l2.035 1.922L10.577 13.78.397 2.151 2.432.23z' fill='%23000000' fill-rule='nonzero'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
    margin-left: measure(quarter);
    transition: transform 140ms ease-in;
  }
}

.expandable-information__toggler svg {
  width: 1.3rem;
  height: 1.3rem;
  margin-right: measure(quarter);
  color: color(yellow-1);
}

.expandable-information--is-expanded .expandable-information__toggler::after {
  transform: scale(-1);
}

.expandable-information__content {
  padding-top: measure(quarter);
  padding-left: measure(full);
}
</style>
